import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { setTranslationDetails } from 'slices/translationDetailSlice';
import {
  acceptTranslationDetails,
  rejectTranslationDetails,
  fetchTranslationDetails,
  translationDetailsSelector,
} from 'slices/translationDetailSlice';
import Swal from 'sweetalert2';
import ViewTable from '../views-interpreters/Translations/TranslationRevisionViewTable';
import moment from 'moment';

const TranslationDetails = () => {
  const { translationDetails, loader } = useSelector(translationDetailsSelector);
  const [statusMessage, setStatusMessage] = useState();
  const [status, setStatus] = useState();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const [token] = useState(params?.get('token'));
  const [actionTaken, setActionTaken] = useState(false);
  const hasRevisionRequest = translationDetails?.status === 'Client Request Editing';
  const hideActions =
  actionTaken ||
  translationDetails?.hide_actions ||
  !hasRevisionRequest;

  console.log(translationDetails?.hide_actions)

  useEffect(() => {
    dispatch(fetchTranslationDetails(token, submitCallback));
    return () => {
      dispatch(setTranslationDetails({}));
    };
  }, [token]);

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, { className: 'successToast' });
      setStatusMessage(message);
    } else {
      toast.error(message, { className: 'errorToast' });
      setStatusMessage(message);
      setStatus(status);
    }
  };
console.log('Due date to send:', translationDetails?.translation_details?.due_date);
 const AcceptInvite = async () => {
  try {
    await dispatch(
      acceptTranslationDetails(
        translationDetails?.id,
        { due_date: translationDetails?.translation_details?.requested_due_date }, // 👈 yahan se due_date bhej rahe hain
        submitCallback
      )
    );
      Swal.fire({
      title: 'Revision Accepted!',
      text: 'The due date has been updated successfully.',
      icon: 'success',
      confirmButtonText: 'OK',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // 🔄 reload after OK
      }
    });
    setActionTaken(true);
  } catch (error) {
    Swal.fire({
      title: 'Error!',
      text: 'Something went wrong while accepting.',
      icon: 'error',
    });
  }
};


  const RejectInvite = async () => {
    try {
      await dispatch(rejectTranslationDetails(translationDetails?.id, submitCallback));
      Swal.fire({
        title: 'Revision Rejected!',
        text: 'The request has been rejected.',
        icon: 'error',
      }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // 🔄 reload after OK
      }
    });
    //   dispatch(fetchTranslationDetails(token, submitCallback));
    setActionTaken(true);
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Something went wrong while rejecting.',
        icon: 'error',
      });
    }
  };

  if (loader) {
    return (
      <div className="loader_wrapper" style={{display: 'flex',alignItems: 'center',justifyContent: 'center', height: '100vh'}}>
        <Spinner size="xl">Loading...</Spinner>
      </div>
    );
  }

  console.log('translation data fetched', translationDetails);

  const rawDatetime =
    translationDetails?.date + ' ' + translationDetails?.start_time;
  const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format(
    'MMM D, YYYY HH:mm:ss'
  );

  return (
    <>
      {/* {statusMessage === 'Data retrieved successfully.' &&
      translationDetails ? ( */}
        <div className="main-freePage">
          <img src="/images/logo.png" alt="" />
          <div className="table_wrapper">
            <div className="row_main_head bg-primary-secondaryCard">
              <h2 className={`main_heading main_heading1`}>
                View Translation # {translationDetails?.transid}
              </h2>
              {/* {translationDetails?.status && (
                <span className="main_heading main_heading1">
                  Status: {translationDetails?.status}
                </span>
              )} */}
            </div>

            <div className="row_main_head bg-light-secondaryCard mt-3">
              <div className="mb-3">
                <div className="text-transform-capitalize main_heading2">
                    LANGUAGE:
                  <span className="appLanguage">
                    {
                      translationDetails?.translation_target_languages?.[0]
                        ?.language?.name
                    }
                  </span>
                </div>
              </div>
            </div>

            <div className="px-2">
              <ViewTable
                item={translationDetails}
                onAccept={AcceptInvite}
                onReject={RejectInvite}
                hideActions={hideActions}
              />
            </div>
          </div>
        </div>
      {/* ) : statusMessage === 'Page Expired' ? (
        <div className="error-page-container">
          <img src="/images/logo.png" alt="" />
          <h4>OOps! {statusMessage}</h4>
          <Link to="/" className="main_button mt-5">
            Go to home page
          </Link>
        </div>
      ) : (
        <div className="error-page-container">
          <img src="/images/logo.png" alt="" />
          <h4>Oopps! The page you were looking for doesn't exist.</h4>
          <p>
            <Link to="/" className="button">
              Go to home page
            </Link>
          </p>
        </div>
      )} */}
    </>
  );
};

export default TranslationDetails;
